import { useEffect, useState } from 'react';
import { ClickToCallEnergy, IClickToCallCallEnergy, VfModal } from '@vfit/shared/components';
import { AppMobile, checkWindow } from '@vfit/shared/data-access';
import { IActionSlide } from '@vfit/shared/models';
import { ContainerEnergy } from './clickToCallEnergyWrapper.style';
import { IProduct } from '@vfit/consumer/data-access';
import { removeCurrency } from '@vfit/consumer/hooks';

const ClickToCallEnergyWrapper = () => {
  const initialConfig: IClickToCallCallEnergy = {
    url: '',
    entryPoint: '',
  };

  const setModalHeight = () => {
    const defaultValue = 563;
    if (!checkWindow()) return defaultValue;
    const height = window?.innerHeight;
    if (!height) return defaultValue;
    return height - (height * 30) / 100;
  };

  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalDetail, setModalDetail] = useState<IClickToCallCallEnergy>(initialConfig);

  const actionEnergyCtc = (event) => {
    const { detail } = event as CustomEvent as {
      detail: {
        product: IProduct;
        action: IActionSlide;
      };
    };
    setModalDetail({
      url: detail?.action?.url || '',
      entryPoint: detail?.action?.localUrl || '',
      pageProduct: {
        product_id: detail?.product?.offerId?.toString() || '',
        product_name: detail?.product?.title || '',
        product_price: removeCurrency(detail?.product?.price || ''),
        product_quantity: '1',
        product_category: detail?.product?.category || 'fixed',
      },
    });
    setShowModal(true);
  };

  const resetModalStatus = () => {
    setModalDetail(initialConfig);
    setShowModal(false);
  };

  const handleCloseModal = () => {
    resetModalStatus();
  };

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('energyCtcNotificationEvent', actionEnergyCtc);
    }
    return () => document.removeEventListener('energyCtcNotificationEvent', actionEnergyCtc);
  }, []);

  return (
    <VfModal
      wrapperId={'ctc-energy'}
      height={setModalHeight()}
      isOpen={showModal}
      handleClose={handleCloseModal}
      isModalFullContainer={AppMobile.checkIsApp()}
    >
      <ContainerEnergy isApp={AppMobile.checkIsApp()}>
        <ClickToCallEnergy
          url={modalDetail.url}
          entryPoint={modalDetail.entryPoint}
          taggingOpts={modalDetail?.taggingOpts}
          pageProduct={modalDetail?.pageProduct}
        />
      </ContainerEnergy>
    </VfModal>
  );
};

export default ClickToCallEnergyWrapper;
